import React from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import About from "../components/About";
import Services from "../components/Services";
import Sectors from "../components/Sectors";
import Method from "../components/Method";
import Portfolio from "../components/Portfolio";
import Faq from "../components/Faq";
import Devis from "../components/Devis";
import WhatsAppButton from "../components/WhatsAppButton";

const Home = () => (
  <div className="grain relative bg-[#050505]">
    <Nav />
    <WhatsAppButton />
    <main>
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Portfolio />
      <Sectors />
      <Method />
      <Faq />
      <Devis />
    </main>
  </div>
);

export default Home;
